import React from 'react';

function TeamSelector({ teams, selectedTeamId, onChange }) {
  return (
    <div className="form-group">
      <label htmlFor="selectedTeamId">Your Team *</label>
      <select
        id="selectedTeamId"
        name="selectedTeamId"
        value={selectedTeamId}
        onChange={(e) => onChange(e.target.value)}
        required
      >
        <option value="">Select your team</option>
        {teams.map((team) => (
          <option key={team.id} value={team.id}>
            {team.name}
            {team.orgAcronym ? ` (${team.orgAcronym})` : ''}
          </option>
        ))}
      </select>
    </div>
  );
}

export default TeamSelector;
